GP.models.Premium = Backbone.Model.extend({
    idAttribute:'premium_content_id',
    defaults:{
        id: null,
        premium_content_id: null,
        duid: null,
        type: null,
        status: null,
        file_md5: null,
        url: null,
        caption: null,
        credits: null,
        ctime: null,
        placeholder_thumb: false,
        from_ajax: false,
        online_status: 'OFFLINE',
        purchased: false,
        content_na: null, // content not available,
        tags: [],
    },
    initialize: function(data) {

    }
});
